// api/propertyService.js
import axios from 'axios';
import { API_BASE_URL } from '../config';

export const propertyService = {
  // Get all properties
  getAllProperties: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/asset-mgmt/property-map/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching properties:', error);
      // Return mock data for development
    //   return getMockProperties();
    }
  },

  // Get properties by type
  getPropertiesByType: async (type) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/asset-mgmt/property-map/?type=${type}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching properties by type:', error);
    //   return getMockProperties().filter(p => p.type === type);
    }
  },

  // Get property by ID
  getPropertyById: async (id) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/asset-mgmt/property-map/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching property:', error);
    //   return getMockProperties().find(p => p.id === id);
    }
  }
};
